module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-drawer"
  }, [_c('div', {
    staticClass: "vux-drawer-body",
    style: ({
      transform: ("translate3d(" + _vm.translateX + "px, 0, 0)")
    })
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "drawer-mask",
    class: _vm.show ? 'vux-drawer-active' : '',
    on: {
      "click": _vm.hideMask
    }
  })], 2), _vm._v(" "), _c('div', {
    ref: "drawer",
    staticClass: "vux-drawer-content",
    class: [_vm.placement !== 'left' ? 'drawer-right' : 'drawer-left', _vm.show ? 'vux-drawer-active' : ''],
    style: (_vm.drawerStyle)
  }, [_vm._t("drawer")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-767fd25a"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/drawer/index.vue
// module id = 204
// module chunks = 1